import Vue from 'vue';
import VueX from 'vuex';
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import helpers from "@/plugins/helpers";

// plugins
import VueRouter from 'vue-router';
import VueBootstrap from 'bootstrap-vue';
import VueNVD3 from 'vue-nvd3';
import VueInsProgressBar from 'vue-ins-progress-bar';
import VueEventCalendar from 'vue-event-calendar';
import VueSparkline from 'vue-sparklines';
import * as VueGoogleMaps from 'vue2-google-maps';
import Vueditor from '@agametov/vueditor';
import VueHljs from 'vue-hljs';
import VueSweetalert2 from 'vue-sweetalert2';
import VueNotification from 'vue-notification';
import VuePanel from './plugins/panel/';
// import VueDateTimePicker from 'vue-bootstrap-datetimepicker';
import VueSelect from 'vue-select';
// import VueDatepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import VueMaskedInput from 'vue-maskedinput';
import VueInputTag from 'vue-input-tag';
import VueSlider from 'vue-slider-component';
import VueGoodTable from 'vue-good-table';
import VueFullCalendar from 'vue-full-calendar';
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueColorpicker from 'vue-pop-colorpicker';
import VueCustomScrollbar from 'vue-custom-scrollbar';
import VueApexCharts from 'vue-apexcharts';
import DateRangePicker from 'vue2-daterange-picker';
// import datePicker from "vue-bootstrap-datetimepicker";
import datePicker from "vuejs-datepicker";

// plugins css
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'nvd3/build/nv.d3.min.css';
import 'vue-event-calendar/dist/style.css';
import 'vue-hljs/dist/vue-hljs.min.css';
import '@agametov/vueditor/dist/style/vueditor.min.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import 'simple-line-icons/css/simple-line-icons.css';
import 'flag-icon-css/css/flag-icon.min.css';
import 'ionicons/dist/css/ionicons.min.css';
import 'vue-good-table/dist/vue-good-table.css';
import 'fullcalendar/dist/fullcalendar.css';
import 'vue-select/dist/vue-select.css';
import 'vue-slider-component/theme/antd.css';

// color admin css
// import './assets/css/default/app.min.css';
// import './scss/vue.scss';
import './scss/styles.scss';
import 'bootstrap-social/bootstrap-social.css';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

import App from './App.vue';
import Vuelidate from "vuelidate";
import VueCurrencyFilter from "vue-currency-filter";
import Gravatar from 'vue-gravatar';

Vue.config.productionTip = process.env.NODE_ENV === "production" || false;

Vue.use(VueX);
Vue.use(VueRouter);
Vue.use(VueBootstrap);
Vue.use(VueNVD3);
Vue.use(VueEventCalendar, {locale: 'en'});
Vue.use(VueSparkline);
Vue.use(Vueditor);
Vue.use(VueHljs);
Vue.use(VueSweetalert2);
Vue.use(VueNotification);
Vue.use(VuePanel);
// Vue.use(VueDateTimePicker);
Vue.use(VueGoodTable);
Vue.use(VueFullCalendar);
Vue.use(VueColorpicker);
// Vue.use(datePicker);

Vue.use(VueGoogleMaps, {
  load: {
    key: '',
    libraries: 'places'
  }
});
Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px'
});
Vue.use(helpers, { $store: store, $router: router,  $i18n: i18n, $swal: Vue.swal});
Object.defineProperty(Vue.prototype, '$_', { value: _ });
Vue.use(VueCurrencyFilter, {
  symbol: "",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "front",
  symbolSpacing: false
});

Vue.component('v-select', VueSelect);
Vue.component('datepicker', datePicker);
Vue.component('masked-input', VueMaskedInput);
Vue.component('input-tag', VueInputTag);
Vue.component('vue-slider', VueSlider);
Vue.component('vue-custom-scrollbar', VueCustomScrollbar);
Vue.component('apexchart', VueApexCharts);
Vue.component(VueCountdown.name, VueCountdown);
Vue.component('v-gravatar', Gravatar);

Vue.use(DateRangePicker);
// Vue.use(DatePicker);
Vue.use(Vuelidate);
import moment from "moment";
Object.defineProperty(Vue.prototype, "$moment", { value: moment });
// import 'moment/locale/zh-cn';

router.beforeEach((to, from, next) => {
  let query = to.fullPath.match(/^\/$/) ? {} : { redirect: to.fullPath };
  let path = "/denied";
  // console.log(to)
  if (
    to.matched.some(record => {
      return record.meta.requiredLoggedIn && record.meta.includedPages;
    })
  ) {
    if (!store.getters.isLoggedIn) {
      if (next) {
        next({ path: path, query: query });
      }
      return;
    }

    let haveRole = false;
    let roles = store.getters.authorityRole;
    let tFlag = store.getters.getTournamentFlag;

    if(roles == "SUB_PRI") {
      let pages = to.matched[0].meta.includedPages;
      let access = store.getters.accessRoles.authority_option;
      access = access.split(',');
      if(to.path != "/subAccount") {
        if(to.path == '/editBetLimit'){
          if (store.getters.accountType == 2){
            for (var j = 0; j < access.length; j++) {
              if (access[j] == "edit_limit") {
                haveRole = true;
                break;
              }
            }
          }
        } else if(to.path == '/ipSettings'){
          if (store.getters.accountType == 3){
            for (var j = 0; j < access.length; j++) {
              if (access[j] == "edit_account") {
                haveRole = true;
                break;
              }
            }
          }
        }
        else if(to.path == '/newAccount'){
          if (store.getters.accountType == 2){
            for (var j = 0; j < access.length; j++) {
              if (access[j] == "edit_account") {
                haveRole = false;
                break;
              }
            }
          }else{
            for (var j = 0; j < access.length; j++) {
              if (access[j] == "edit_account") {
                haveRole = true;
                break;
              }
            }
          }
        }
        else if(to.path == '/betListHDPOU' || to.path == '/betListOXTOEML' || to.path == '/betListCS' || to.path == '/betListTG' || to.path == '/betListHTFT' ||
              to.path == '/betListDC' || to.path == '/betListFGLG' ||to.path == '/betList' ||to.path == '/memberOutstanding'){
          for (var j = 0; j < access.length; j++) {
            if (access[j] == "report") {
              haveRole = true;
              break;
            }
          }
        }
        else if(to.path == '/tournamentMatch'){
          if (store.getters.accountType == 2){
            for (var j = 0; j < access.length; j++) {
              if (access[j] == "account" && tFlag == true) {
                haveRole = true;
                break;
              }
            }
          }
        }
        else{
          for (var i = 0; i < pages.length; i++) {
            for (var j = 0; j < access.length; j++) {
              if (access[j] == pages[i]) {
                haveRole = true;
                break;
              }
            }
          }
        }
      }
      if (haveRole == false) {
        next({ path: path, query: query });
        return;
      }
    } else {
      haveRole = true;
      if(to.path == '/editBetLimit'){
        if (store.getters.accountType == 2){
          haveRole = true;
        }else{
          haveRole = false;
        }
      }
      else if(to.path == '/ipSettings'){
        if (store.getters.accountType == 3){
          haveRole = true;
        }else{
          haveRole = false;
        }
      }
      else if(to.path == '/newAccount'){
        if (store.getters.accountType == 2){
          haveRole = false;
        }else{
          haveRole = true;
        }
      }
      else if(to.path == '/betListHDPOU' || to.path == '/betListOXTOEML' || to.path == '/betListCS' || to.path == '/betListTG' || to.path == '/betListHTFT' ||
              to.path == '/betListDC' || to.path == '/betListFGLG' ||to.path == '/betList' ||to.path == '/memberOutstanding'){
        if (store.getters.accountType == 2){
          haveRole = true;
        }else{
          haveRole = false;
        }
      }
      else if(to.path == '/tournamentMatch'){
        if (store.getters.accountType == 2 && tFlag == true){
          haveRole = true;
        }else{
          haveRole = false;
        }
      }
      if (haveRole == false) {
        next({ path: path, query: query });
        return;
      }
    }
  }
  if (next) {
    try {
      next();
    } catch (err) {
      return;
    }
  }
});

i18n.locale = store.state.layout.language;

new Vue({
  router,
  store,
  i18n,
  mounted() {
    console.log("ready");
    // this.$store.dispatch("layout/setLanguage", this.$store.getters.language);
  },
  render: h => h(App)
}).$mount('#app');
